import { MessageMedium } from 'constants/messageMediums';
import { getAlertValues } from 'modules/campaigns/alerts/context/AlertsFormProvider.utils';
import { AlertMetricsByMedium, CampaignAlert } from 'modules/campaigns/alerts/types';
import { CampaignTypeFilter } from 'modules/domains/campaign';

export const getOverridesFormInitialValues = (
  allAlertMetrics: AlertMetricsByMedium,
  campaignType: CampaignTypeFilter,
  alertOverrides: CampaignAlert[],
  medium: MessageMedium,
) => {
  return allAlertMetrics[medium]?.reduce((acc, metric) => {
    const { metricName, valueType } = metric;
    const savedAlert = alertOverrides?.find((m) => m.metricName === metricName);
    const alert = getAlertValues({
      savedAlert,
      medium,
      type: campaignType,
      metricName,
      valueType,
    });
    return { ...acc, ...alert };
  }, {});
};
